import axios from "axios";

/**
 * Safety net for the forced-password-change gate.
 *
 * App.tsx already keeps a flagged user on the change-password screen, but a
 * component can fire a request before that effect runs, and the API answers
 * every one of them with this code. Rather than let those turn into a
 * screenful of silent failures, send the user where the API is pointing.
 *
 * A full page load rather than a router navigate, because this runs outside
 * React and has no navigator to call.
 */
export const PASSWORD_CHANGE_REQUIRED = "password_change_required";

export const CHANGE_PASSWORD_PATH = "/change-password";

export const installPasswordGate = () => {
    axios.interceptors.response.use(
        response => response,
        error => {
            const isGate = error?.response?.status === 403
                && error?.response?.data?.detail === PASSWORD_CHANGE_REQUIRED;

            if (isGate && !window.location.pathname.includes("change-password")) {
                window.location.href = CHANGE_PASSWORD_PATH;
            }

            return Promise.reject(error);
        }
    );
};
